import React, { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DiscountCouponService from "./Discountcoupons.service";
import AuthService from "../Authentication/auth.service";
import Alerts from "../../components/Alerts/alerts";
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Col, CardBody, Card } from "reactstrap";
import PermissionAccess from '../../PermissionAccess/Access.js';
//fine
const EditDocumentSettingsModal = ({ showModalEditDiscountCoupon, handleToggleModalEditDiscountCoupon, id, onSuccess }) => {
  //console.log('ID :'+id);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();

  const [data, setData] = useState({
    title: '',
    icon: '',
    status: '',
    type: '',
    specializations: [],
  });

  const [errors, setErrors] = useState({
    title: '',
    icon: '',
    status: '',
    type: '',
    specializations: '',
  });

  // const specializationOptions = [
  //   { value: "67348e3792e6c4d087216b16", label: t("Cardiology") },
  //   { value: "67348e5692e6c4d087216b17", label: t("Dermatology") },
  //   { value: "67348e7892e6c4d087216b18", label: t("Neurology") },
  //   { value: "67348e9992e6c4d087216b19", label: t("Orthopedics") }
  // ];

  const [specializationOptions, setSpecializationOptions] = useState([]);

  useEffect(() => {
    const fetchSpecializations = async () => {
      setLoading(true);
      DiscountCouponService.getAllSpecializations(authData.sessionID, 0, 9999999, '', '', '').then((response) => {
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          if (response.data.status === true) {
            const options = response.data.data.map(spec => ({
              value: spec._id,
              label: spec.name
            }));
            // Add Select All option at the top
            setSpecializationOptions([{ value: '__all__', label: t('Select All') }, ...options]);
          } else {
            Alerts.swalErrorAlert(t("Something went wrong, Please try again."));
          }
        }
      }, (error) => {
        setLoading(false);
        const errContent = (error.response && error.response.data) || error.message || error.toString();
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      });
    };
    fetchSpecializations();
  }, [authData.sessionID, navigate, t]);
  

  //get data
  useEffect(() => {
    const fetchData = async () => {
        setLoading(true);
        DiscountCouponService.GetSingleDocument(authData.sessionID,id).then((response) => {
            setLoading(false);
            if (response.data.message === "Unauthorized") {
                AuthService.logout();
                navigate("/login");
                window.location.reload();
            } else {
                if (response.data.status == true) {
                    setData({
                        title: response.data.data.data.title,
                        icon: response.data.data.data.icon,
                        status: response.data.data.data.status,
                        type: response.data.data.data.type,
                        specializations: response.data.data.data.specializations || [],
                      });
                  }
                  else {
                    Alerts.swalErrorAlert(t("Something went wrong, Please try again."));
                  }
            }
        }, (error) => {
            setLoading(false);
            const errContent = (error.response && error.response.data) || error.message || error.toString();
            if (errContent) {
                //Alerts.swalErrorAlert(errContent);
            } else {
                Alerts.swalErrorAlert(t("Server Error, Please try again later."));
            }
        });
    };
    fetchData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let error = '';
  
    if (name === 'title' && !value) {
      error = 'Title is required';
    }  else if (name === 'icon') {
      if (!value) error = 'Icon is required';
    } else if (name === 'status' && !value) {
      error = 'Status is required';
    } else if (name === 'type' && !value) {
      error = 'Type is required';
    }
  
    setErrors({ ...errors, [name]: error });
    setData({ ...data, [name]: value });
  };

  const handleSpecializationChange = (selectedOptions) => {
    if (!selectedOptions) {
      setData(prevData => ({ ...prevData, specializations: [] }));
      setErrors(prevErrors => ({ ...prevErrors, specializations: 'At least one specialization is required' }));
      return;
    }
    
    // Check if Select All was clicked
    const selectAllOption = selectedOptions.find(option => option.value === '__all__');
    const allOptions = specializationOptions.filter(option => option.value !== '__all__');
    
    if (selectAllOption) {
      // If Select All was clicked, select all options (but don't include Select All itself)
      setData(prevData => ({ ...prevData, specializations: allOptions.map(option => option.value) }));
      setErrors(prevErrors => ({ ...prevErrors, specializations: '' }));
    } else {
      // Regular selection - filter out Select All from the selected values
      const selectedValues = selectedOptions
        .filter(option => option.value !== '__all__')
        .map(option => option.value);
      setData(prevData => ({ ...prevData, specializations: selectedValues }));
      setErrors(prevErrors => ({ ...prevErrors, specializations: selectedValues.length > 0 ? '' : 'At least one specialization is required' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let validationErrors = {};

    if (!data.title) { validationErrors.title = 'Title is required'; }
    if (!data.icon) { validationErrors.icon = 'Icon is required'; }
    if (!data.status) { validationErrors.status = 'Status is required'; }
    if (!data.type) { validationErrors.type = 'Type is required'; }
    if (data.specializations.length === 0) { validationErrors.specializations = 'At least one specialization is required'; }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setLoading(true);
      DiscountCouponService.EditDocument(authData.sessionID,data,id).then((response) => {
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          if (response.data.status === true) {
            handleToggleModalEditDiscountCoupon();
            onSuccess();
            Alerts.swalSuccessAlert(t("Document updated successfully."));
          } else {
            validationErrors.coupon_code = response.data.message || 'An error occurred';
            setErrors(validationErrors);
          }
        }
      }, (error) => {
        setLoading(false);
        const errContent = (error.response && error.response.data) || error.message || error.toString();
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      });
    }
  };

  const handleClose = () => {
    setErrors({
      title: '',
      icon: '',
      status: '',
      type: '',
      specializations: '',
    });
    handleToggleModalEditDiscountCoupon();
  };

  return (
    <div className={showModalEditDiscountCoupon ? "modal d-block mt-4" : "modal"} style={{ display: showModalEditDiscountCoupon ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }} tabIndex="-1" role="dialog">
      <form onSubmit={handleSubmit}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{t("Edit Document")}</h5>
            </div>
            <div className="modal-body">
            <Col md="12">
                <Card className="main-card mb-3">
                     <CardBody>
              <LoadingOverlay
                tag="div"
                active={loading}
                styles={{ overlay: (base) => ({ ...base }) }}
                spinner={<DNALoader />}
              >
                { /* All inner content of LoadingOverlay */ }
                <input type="hidden" className="form-control" name="business_id" />

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="coupon-code" className="col-form-label">{t("Title")}:</label>
                      <input type="text" className="form-control" placeholder="Enter Title" 
                      name="title"
                      onChange={handleChange}
                      value={data.title}
                      />
                      {errors.title && <strong className="error text-danger">{errors.title}</strong>}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="coupon-code" className="col-form-label">{t("Icon")}:</label>
                      <input type="text" className="form-control" placeholder="Enter Icon" 
                      name="icon"
                      onChange={handleChange}
                      value={data.icon}
                      />
                      {errors.icon && <strong className="error text-danger">{errors.icon}</strong>}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="status-select" className="col-form-label">{t("Status")}:</label>
                      <select className="form-control" 
                      name="status"
                      onChange={handleChange}
                      value={data.status}
                      >
                        <option value="">{t("Select Status")}</option>
                        <option value="Active">{t("Active")}</option>
                        <option value="InActive">{t("InActive")}</option>
                      </select>
                      {errors.status && <strong className="error text-danger">{errors.status}</strong>}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="type-select" className="col-form-label">{t("Type")}:</label>
                      <select className="form-control"
                      name="type"
                      onChange={handleChange}
                      value={data.type}
                      >
                        <option value="">{t("Select Type")}</option>
                        <option value="Doctor">{t("Doctor")}</option>
                        <option value="Nurse">{t("Nurse")}</option>
                        <option value="Both">{t("Both")}</option>
                      </select>
                      {errors.type && <strong className="error text-danger">{errors.type}</strong>}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="specializations" className="col-form-label">{t("Specializations")}:</label>
                      <Select
                        isMulti
                        name="specializations"
                        options={specializationOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={specializationOptions.filter(option => data.specializations.includes(option.value) && option.value !== '__all__')}
                        onChange={handleSpecializationChange}
                      />
                      {errors.specializations && <strong className="error text-danger">{errors.specializations}</strong>}
                    </div>
                  </div>
                </div>

                <div className="text-center mt-4">
                  <button type="button" className="btn btn-outline-light btn-hover-shine me-3" onClick={handleClose}>{t("Close")}</button>
                  <button type="submit" className="btn btn-custom-color">{t("Save")}</button>
                </div>
              </LoadingOverlay>
                                        </CardBody>
                                    </Card>
                                </Col>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

EditDocumentSettingsModal.propTypes = {
    showModalEditDiscountCoupon: PropTypes.bool.isRequired,
    handleToggleModalEditDiscountCoupon: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired, // Ensure id is required and of type string or number
  };

export default EditDocumentSettingsModal;
